<template><!-- svgo-optimised -->
<svg class="icon icon__menu" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M15 8.5H1V7.5H15V8.5Z" fill="currentColor"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M15 5H1V4H15V5Z" fill="currentColor"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M15 12H1V11H15V12Z" fill="currentColor"/>
</svg>
</template>